import {applyMiddleware, combineReducers, createStore, compose} from 'redux';
import {routerMiddleware, connectRouter} from 'connected-react-router';
import {createBrowserHistory} from 'history';
import thunk from 'redux-thunk';
import queryString from 'query-string';

/* reducers */
import {reducer as formReducer} from 'redux-form';
import productReducer from './reducers/productReducer';
import detailViewReducer from './reducers/detailViewReducer';
import configReducer from './reducers/configReducer';
import viewReducer from './reducers/viewReducer';
import cartReducer from './reducers/cartReducer';
import customerReducer from './reducers/customerReducer';
import menuReducer from './reducers/menuReducer';
import pageReducer from './reducers/pageReducer';
import modalReducer from './reducers/modalReducer';
import addressReducer from './reducers/addressReducer';
import historyReducer from './reducers/historyReducer';
import userReducer from './reducers/userReducer';
import signupReducer from './reducers/signupReducer';
import uploadReducer from './reducers/uploadReducer';
import overlayingModalReducer from './reducers/overlayingModalReducer';
import orderReducer from './reducers/orderReducer';
import holdProductReducer from './reducers/holdProductReducer';
import versionReducer from './reducers/versionReducer';
import summaryReducer from './reducers/summaryReducer';
import {version} from './reducers/versionReducer';
import autoScrollReducer from './reducers/autoScrollReducer';
import userActivityReducer from './reducers/userActivityReducer';
import checkoutReducer from './reducers/checkoutReducer';
import paymentKioskReducer from './reducers/paymentKioskReducer';
import filterReducer from './reducers/filterReducer';
import customerTypeReducer from './reducers/customer_type_reducer';

/* middleware */
import productMiddleware from './middleware/productMiddleware';
import locationMiddleware from './middleware/locationMiddleware';
import kioskWarningReducer from './reducers/kioskWarningReducer';
import kioskUserReducer from './reducers/kioskUserReducer';
import ticketCalculatorMiddleware from './middleware/ticketCalculatorMiddleware';
import patientLimitsMiddleware from './middleware/patientLimitsMiddleware';
import productReloadMiddleware from './middleware/productReloadMiddleware';
import lazyLoadReducer from "./reducers/lazyLoadReducer";
import salesChannelReducer from "./reducers/salesChannelReducer";
import {paymentKioskMiddleware} from './middleware/paymentKioskMiddleware';
import uriReducer from './reducers/uri_reducer';

function preserveQueryParameters(history, location) {
  const currentQuery = queryString.parse(history.location.search);
  if (currentQuery) {
      if (location.search) {
          Object.assign(currentQuery, queryString.parse(location.search));
      }
      location.search = queryString.stringify(currentQuery);
  }
  return location;
}

function createLocationDescriptorObject(location, state) {
  return typeof location === 'string' ? { pathname: location, state } : location;
}

function createPreserveQueryHistory(createHistory) {
  return (options) => {
      const history = createHistory(options);
      const oldPush = history.push, oldReplace = history.replace;
      history.push = (path, state) => oldPush.apply(history, [preserveQueryParameters(history, createLocationDescriptorObject(path, state))]);
      history.replace = (path, state) => oldReplace.apply(history, [preserveQueryParameters(history, createLocationDescriptorObject(path, state))]);
      return history;
  };
}

export const history = createBrowserHistory();

const LOCAL_STORAGE = 'state';
const reducers = combineReducers({
  config: configReducer,
  products: productReducer,
  detailView: detailViewReducer,
  view: viewReducer,
  cart: cartReducer,
  history: historyReducer,
  customer: customerReducer,
  customerType: customerTypeReducer,
  router: connectRouter(history),
  form: formReducer,
  menu: menuReducer,
  modal: modalReducer,
  page: pageReducer,
  address: addressReducer,
  user: userReducer,
  kioskUser: kioskUserReducer,
  signup: signupReducer,
  upload: uploadReducer,
  overlayingModal: overlayingModalReducer,
  orders: orderReducer,
  holdProduct: holdProductReducer,
  version: versionReducer,
  summary: summaryReducer,
  checkout: checkoutReducer,
  autoScrollReducer,
  userActivityReducer,
  kioskWarningReducer,
  lazyLoad: lazyLoadReducer,
  paymentKiosk: paymentKioskReducer,
  salesChannel: salesChannelReducer,
  uri: uriReducer,
  filter: filterReducer,
});

// const composeEnhancers = composeWithDevTools({
//   // Specify name here, actionsBlacklist, actionsCreators and other options if needed
// });

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // add support for Redux dev tools
// dev
const middleware = composeEnhancers(
  applyMiddleware(
    thunk,
    productMiddleware,
    productReloadMiddleware,
    ticketCalculatorMiddleware,
    patientLimitsMiddleware,
    paymentKioskMiddleware,
    routerMiddleware(history),
    locationMiddleware,
  ),
);
// prod
// const middleware = applyMiddleware(thunk, productMiddleware, routerMiddleware(history));

// const middleware = applyMiddleware(thunk, createLogger(), productMiddleware, routerMiddleware(history));

let persistedState = localStorage.getItem(LOCAL_STORAGE) ? JSON.parse(localStorage.getItem(LOCAL_STORAGE)) : {};
persistedState = persistedState.version === version ? persistedState : {};
const store = createStore(reducers, persistedState, middleware);

// const store = createStore(reducers, composeEnhancers(
//   middleware,
//   // other store enhancers if any
// ));
// const history = syncHistoryWithStore(createBrowserHistory(), store);

// persist state

store.subscribe(() => {
  const reduxStore = store.getState();
  localStorage.setItem(LOCAL_STORAGE, JSON.stringify({
    address: reduxStore.address,
    user: {
      ...reduxStore.user,
      tempUser: {},
      tokens: {
        ...reduxStore.user.tokens,
        refreshTokenPending: false
      },
      isFetched: false
    },
    kioskUser: {
      ...reduxStore.kioskUser,
      tempUser: {},
      tokens: {
        ...reduxStore.kioskUser.tokens,
        refreshTokenPending: false
      }
    },
    cart: reduxStore.cart,
    orders: reduxStore.orders,
    taxes: reduxStore.taxes,
    version: reduxStore.version,
    view: { layoutType: reduxStore.view.layoutType },
  }));
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js